import { DtoBase } from "../../../Assessment-Platform-1.0-Dtos-FE/src/dtos/DtoBase";
export class MultiSetSectionDto {
}
export class MultiSetQuestionDto {
}
export class OptionDto extends DtoBase {
}
export var OptionValue;
(function (OptionValue) {
    OptionValue["A"] = "A";
    OptionValue["B"] = "B";
    OptionValue["C"] = "C";
    OptionValue["D"] = "D";
    OptionValue["E"] = "E";
    OptionValue["F"] = "F";
    OptionValue["G"] = "G";
    OptionValue["H"] = "H";
    OptionValue["I"] = "I";
    OptionValue["J"] = "J";
})(OptionValue || (OptionValue = {}));
export var ProctoringStatusEnum;
(function (ProctoringStatusEnum) {
    ProctoringStatusEnum["STARTED"] = "started";
    ProctoringStatusEnum["COMPLETED"] = "completed";
    ProctoringStatusEnum["INTERVIEW_NOT_YET_STARTED"] = "interview_not_yet_started";
    ProctoringStatusEnum["FAILED"] = "failed";
})(ProctoringStatusEnum || (ProctoringStatusEnum = {}));
/** Status of the proctor report trigger pipeline (`proctorReport.status`). */
export var ProctorTriggerStateEnum;
(function (ProctorTriggerStateEnum) {
    ProctorTriggerStateEnum["PENDING"] = "PENDING";
    ProctorTriggerStateEnum["PROCESSING"] = "PROCESSING";
    ProctorTriggerStateEnum["FINISHED"] = "FINISHED";
    ProctorTriggerStateEnum["ERROR"] = "ERROR";
})(ProctorTriggerStateEnum || (ProctorTriggerStateEnum = {}));
export var UserQualificationStatusEnum;
(function (UserQualificationStatusEnum) {
    UserQualificationStatusEnum["QUALIFIED"] = "qualified";
    UserQualificationStatusEnum["NOT_QUALIFIED"] = "not_qualified";
    UserQualificationStatusEnum["NOT_APPLICABLE"] = "not_applicable";
    UserQualificationStatusEnum["DISQUALIFIED"] = "disqualified";
})(UserQualificationStatusEnum || (UserQualificationStatusEnum = {}));
export var ScoreDeductionStatusEnum;
(function (ScoreDeductionStatusEnum) {
    ScoreDeductionStatusEnum["DEDUCTED"] = "deducted";
    ScoreDeductionStatusEnum["NOT_DEDUCTED"] = "not_deducted";
    ScoreDeductionStatusEnum["NOT_APPLICABLE"] = "not_applicable";
})(ScoreDeductionStatusEnum || (ScoreDeductionStatusEnum = {}));
export var SeverityEnum;
(function (SeverityEnum) {
    SeverityEnum["VIOLATED"] = "Violated";
    SeverityEnum["CLEAR"] = "Clear";
    SeverityEnum["SUSPICIOUS"] = "Suspicious";
})(SeverityEnum || (SeverityEnum = {}));
